import React, { useContext, useEffect } from "react";
import { BreadcrumbsStyled } from "./BreadcrumbsStyled";
import { useSelector } from "react-redux";
import { getBreadcrumbs } from "./slice/selectors";
import { useLocation, Link } from "react-router-dom";
import { WebConfiguratorPath } from "../../routes/routes";
import { useAppDispatch } from "../../store/store";
import { removeBreadcrumbsItem } from "./slice/BreadcrumbsSlice";
import { TranslationContextInterface } from "../../entities/Language";
import { TranslationContext } from "../../context/TranslationContext";
import { getValueForKey } from "../../context/translationsUtils";

const Breadcrumbs: React.FC = () => {
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  const dispatch = useAppDispatch();
  const breadcrumbs = useSelector(getBreadcrumbs);
  const sortedBreadcrumbs = [...breadcrumbs]
    .sort((a, b) => a.level - b.level)
    .filter((item) => item !== undefined);

  const location = useLocation();

  useEffect(() => {
    const routes = [
      WebConfiguratorPath.CUSTOM,
      WebConfiguratorPath.TASTE_HARMONY,
      WebConfiguratorPath.MIXES,
    ];
    if (routes.includes(location.pathname)) {
      dispatch(removeBreadcrumbsItem({ level: 1 }));
    }
  }, [location.pathname, dispatch]);
  return (
    <BreadcrumbsStyled>
      <ul className="breadcrumbs-items">
        <li>
          <Link to="/">{getValueForKey(translations, "nav_bar.home")}</Link>
        </li>
        {sortedBreadcrumbs.map((item) => (
          <li key={item.level}>
            {item.link ? <Link to={item.link}>{item.name}</Link> : item.name}
          </li>
        ))}
      </ul>
    </BreadcrumbsStyled>
  );
};

export default Breadcrumbs;
